import type { MfgTreeNode } from "./useMfgTree";

export function MfgSelectionsForm({
  variants, alternatives, variantSel, altSel, onVariant, onAlt,
}: {
  variants: { node: MfgTreeNode; options: MfgTreeNode[] }[];
  alternatives: { node: MfgTreeNode; options: MfgTreeNode[] }[];
  variantSel: Record<number, number>; altSel: Record<number, number>;
  onVariant: (groupId: number, childId: number) => void;
  onAlt: (groupId: number, childId: number) => void;
}) {
  return (
    <div className="space-y-4">
      {variants.map(({ node, options }) => (
        <fieldset key={node.item.mfgItemId}>
          <legend className="text-sm font-semibold">{node.item.variant?.name ?? node.item.name}</legend>
          <div className="flex flex-wrap gap-3">
            {options.map((o) => (
              <label key={o.item.mfgItemId} className="flex items-center gap-1 text-sm">
                <input type="radio" name={`v-${node.item.mfgItemId}`} checked={variantSel[node.item.mfgItemId] === o.item.mfgItemId} onChange={() => onVariant(node.item.mfgItemId, o.item.mfgItemId)} />
                {o.item.name}
              </label>
            ))}
          </div>
        </fieldset>
      ))}
      {alternatives.map(({ node, options }) => (
        <fieldset key={node.item.mfgItemId}>
          <legend className="text-sm font-semibold">{node.item.alternative?.name ?? node.item.name} (choose one)</legend>
          <div className="flex flex-wrap gap-3">
            {options.map((o) => (
              <label key={o.item.mfgItemId} className="flex items-center gap-1 text-sm">
                <input type="radio" name={`a-${node.item.mfgItemId}`} checked={altSel[node.item.mfgItemId] === o.item.mfgItemId} onChange={() => onAlt(node.item.mfgItemId, o.item.mfgItemId)} />
                {o.item.name}
              </label>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
